module.exports = __webpack_public_path__ + "img/planner.0b9e7d87.svg";